module.exports = __webpack_public_path__ + "img/divide-01.09790e1e.svg";